export default {
    namespaced: true,

    actions: {
        save({ commit }, params) {
            return axios.post('/api/leads/availability', {
                date: params.date,
                selection: params.selection,
            });
        },
    },
};
